import React, { useEffect, useState } from "react";
import { PageLoader } from "../Components/PageLoader";
import { auditGet } from "../../../Model/Network/Config/Axios";
import moment from "moment";
import { SidePane } from "../fSidePane/RightPane";
import { PaginationTable } from "../../Tables/PaginationTable";
import {useParams} from 'react-router-dom';

export default function SystemLogs({type,marginTop="25px"}) {  
    
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({
        currentPage: 1,
        total: 0,
        items: [],
      });
    const [showLogDetails,setShowLogDetails] = useState();
    const {idSystemLog} = useParams();

    const ID=idSystemLog;

    useEffect(() => {
        if (ID) {
            next(ID, 0)
        }
    }, [ID]);

    const next = (ID,page=0) => {
        setLoading(true);
        auditGet(`/workspace/auditLogging/fetchAllLogs`,
            (e, r) => {
                if (r) {
                    setData(r);
                }
                setLoading(false);
            },
            {
                refType: type,
                refId: ID,
                offset: page,
            }
        );
    }
 
    let mapItem = item => { 
        let center = (
            <div onClick={()=>setShowLogDetails(item)} key={item.id} style={{ paddingLeft: 0, paddingRight: 0 }}
                className="border-bottom fintrip-department-item table-item">
                <div className="linear-layout horizontal"
                    style={{ flex: 1, cursor: 'pointer' }}>
                    <div className="inline inline-padding-right flex-2" >
                        <p className="top" style={{fontSize:13,fontWeight:'bold'}}>#{item.apiRequestId}</p>
                    </div>
                    <div className="inline inline-padding-right flex-1">
                        <p style={{ fontSize: 13 }}
                            className="top">{item.actor?item.actor.name:"NA"}</p>
                    </div>
                    <div className="inline inline-padding-right flex-1">
                        <p style={{ fontSize: 13 }}
                            className="top">{item.event?item.event.eventType:"NA"}</p>
                    </div>
                    <div className="inline inline-padding-right flex-1">
                        <p style={{ fontSize: 13 }}
                            className="top">{moment(item.createdAt).format("DD-MM-YYYY h:mm:ss a")}</p>
                    </div>
                </div>
            </div>
        )
        return (
            <div>
                {center}
            </div>
        )

    }

    if (loading) {
        return (<PageLoader />)
    }

    return (
        <div className="title-container" style={{ padding: 20,marginTop:marginTop}}>
            <PaginationTable pagecount={15} pagination={true} page={data.currentPage} length={data.total} data={data.items} pageLoading={loading}
            fetch={(page) => {
                next(ID,page)
            }} mapItem={mapItem}
             headers={[
                {
                    key: "ref_id",
                    name: "Reference ID",
                    weight: 2
                },
                {
                    key: "updatedby",
                    name: "Updated By",
                    weight: 1
                },
                {
                    key: "action",
                    name: "Action",
                    weight: 1
                },
                {
                    key: "updatedat",
                    name: "Updated At",
                    weight: 1
                }
            ]}/>
            {
                showLogDetails &&
                <SidePane button={false} column={false} onClose={() => setShowLogDetails()}>
                    <div className='FadeRight-Effect' style={{ fontSize: '12px', width: '100%' }}>
                        <div style={{ fontWeight: 600, fontSize: '18px', lineHeight: '1.3' }} >Log Details</div>
                        <div style={{ color: 'var(--text-color)', marginBottom: '35px', fontWeight: 600, fontSize: '24px', lineHeight: '1.3' }}>{`#${showLogDetails.apiRequestId}`} </div>
                        <div className='FadeRight-Effect'>
                            <div style={{ fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 10px 0px' }}>Details</div>
                            {showLogDetails.event && showLogDetails.source &&
                                <>
                                    <div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>Event Type: </span>{showLogDetails.event.eventType}</div>
                                    <div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>Event Detail: </span>{showLogDetails.event.details}</div>
                                    <div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>ip: </span>{showLogDetails.source.ip}</div>
                                    <div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>origin: </span>{showLogDetails.source.origin}</div>
                                    <div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>referer: </span>{showLogDetails.source.referer}</div>
                                    <div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>userAgent: </span>{showLogDetails.source.userAgent}</div>                                </>
                            }
                            
                            <div style={{ fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 10px 0px' }}>User</div>
                            {showLogDetails.actor &&
                                <>
                                    <div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>Employee Name: </span>{showLogDetails.actor.name}</div>
                                    <div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>user Type: </span>{showLogDetails.actor.userType}</div>
                                </>
                            }
                        </div>
                    </div>
                </SidePane>
            }
        </div>
    )
}